import React from "react";
import { useSelector } from "react-redux";

const LicenseInfo = () => {
  const workspaceInfo = useSelector((state) => state.userAdmin.licenseInfo);
  return (
    <div className="license__content__info">
      <span className="license__content__info__title">
        Workspace Information
      </span>
      <div>
        <span>Workspace Name</span>
        <span>{workspaceInfo?.workspaceName}</span>
      </div>
      <div>
        <span>Number of Workspace Members</span>
        <span>{workspaceInfo?.totalUsersInWorkspace}</span>
      </div>
      <div>
        <span>Licensed Users</span>
        <span>{workspaceInfo?.licensedUsersInWorkspace}</span>
      </div>
      <div>
        <span>Unlicensed Users</span>
        <span>{workspaceInfo?.unlicensedUsersInWorkspace}</span>
      </div>
      <div className={workspaceInfo?.reservedLicenses === -1 ? "disabled" : ""}>
        <span>Total Reserved Licenses</span>
        <span>
          {workspaceInfo?.reservedLicenses === -1
            ? "N/A"
            : workspaceInfo?.reservedLicenses}
        </span>
      </div>
      <div
        className={
          workspaceInfo?.remainingReservedLicenses === -1 ? "disabled" : ""
        }
      >
        <span>Available Reserved Licenses</span>
        <span>
          {workspaceInfo?.remainingReservedLicenses === -1
            ? "N/A"
            : workspaceInfo?.remainingReservedLicenses}
        </span>
      </div>
    </div>
  );
};

export default LicenseInfo;
